import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Divider,
  Box,
} from "@material-ui/core";
import { green, red, grey, orange } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import HelpIcon from "@material-ui/icons/Help";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import { formatearFecha } from "src/utils/formatTime";

export default function InformacionValidacionModal({ open, onClose, factura }) {
  if (!factura) return null;

  const {
    supervisorValidadorEmpleado,
    fechaValidacionSupervisor,
    estadoValidacionSupervisor,
    estadoPagoEmpleado,
    administradorPagoEmpleado,
    fechaPagoEmpleado,
    montoPagoEmpleado,
    metodoPagoEmpleado,
    comentarioPagoEmpleado,
    comentarioValidacion,
  } = factura;

  const nombreValidador = supervisorValidadorEmpleado
    ? `${supervisorValidadorEmpleado.nombre} ${supervisorValidadorEmpleado.apellidos}`
    : factura.supervisorValidador || "No disponible";

  const nombreAdministradorPago = administradorPagoEmpleado
    ? `${administradorPagoEmpleado.nombre} ${administradorPagoEmpleado.apellidos}`
    : factura.administradorPago || "No disponible";

  const EstadoIcon = ({ estado }) => {
    switch (estado) {
      case "APROBADO":
      case "PAGADO":
        return (
          <CheckCircleIcon style={{ color: green[600], marginRight: 4 }} />
        );
      case "RECHAZADO":
        return <CancelIcon style={{ color: red[500], marginRight: 4 }} />;
      case "NO_APLICA":
        return <DoneAllIcon style={{ color: grey[600], marginRight: 4 }} />;
      default:
        return <HelpIcon style={{ color: orange[500], marginRight: 4 }} />;
    }
  };

  const Dato = ({ label, value, icon }) => (
    <Box display="flex" alignItems="center">
      {icon && <EstadoIcon estado={icon} />}
      <Typography>
        <strong>{label}:</strong> {value || "No disponible"}
      </Typography>
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Validación y Pago</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Validación del Supervisor
          </Typography>

          <Dato label="Supervisor que validó" value={nombreValidador} />
          <Dato
            label="Fecha de validación"
            value={
              fechaValidacionSupervisor
                ? formatearFecha(fechaValidacionSupervisor, "DD/MM/YYYY")
                : null
            }
          />
          <Dato label="Comentario supervisor" value={comentarioValidacion} />
          <Dato
            label="Estado de validación"
            value={estadoValidacionSupervisor}
            icon={estadoValidacionSupervisor}
          />

          <Divider />

          <Typography variant="subtitle2" color="textSecondary">
            Información de Pago
          </Typography>

          <Dato
            label="Administrador que pagó"
            value={nombreAdministradorPago}
          />
          <Dato
            label="Fecha de pago"
            value={
              fechaPagoEmpleado
                ? formatearFecha(fechaPagoEmpleado, "DD/MM/YYYY")
                : null
            }
          />
          <Dato
            label="Monto pagado"
            value={
              montoPagoEmpleado
                ? `$${Number(montoPagoEmpleado).toLocaleString("es-CL")}`
                : null
            }
          />
          <Dato label="Método de pago" value={metodoPagoEmpleado} />
          <Dato
            label="Comentario administración"
            value={comentarioPagoEmpleado}
          />

          <Dato
            label="Estado de pago"
            value={estadoPagoEmpleado}
            icon={estadoPagoEmpleado}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
